module.exports = __webpack_public_path__ + "img/smart-thumbs.bd8f87fe.svg";